// =============================================================================
// deliveryPhotoKey.js — PURE, dependency-free storage-key builder for inbound
// delivery photos. Kept separate from deliveriesSync.js (which pulls in the
// Supabase client) so it can be unit-tested in plain Node with zero setup.
//
// The key groups by the stock_activity row's idem shape
// (idem(siteKey, action, item, day)) as a PREFIX, then appends a per-photo
// `uniq` so two genuinely different deliveries of the same item on the same day
// never collide (which, with upsert, would silently overwrite the first). No
// staff identity ever goes into the path — only site / action / item / day / uniq.
// =============================================================================

// Mirrors stockSync.idem (join + 200-char cap); inlined so this stays pure.
function idem(...parts) {
  return parts.filter((p) => p != null && p !== "").join("|").slice(0, 200);
}

const safe = (s, max) => String(s == null ? "" : s).replace(/[^a-z0-9]+/gi, "_").slice(0, max);

export function extFor(mime) {
  const m = String(mime || "").toLowerCase();
  if (m.includes("png")) return "png";
  if (m.includes("webp")) return "webp";
  if (m.includes("heic") || m.includes("heif")) return "heic";
  if (m.includes("gif")) return "gif";
  return "jpg";
}

// uniq: a per-photo token (the photo's captured-at, or a random id) so distinct
// same-item/same-day deliveries get distinct keys. Stable input -> stable key,
// so a retry of the SAME photo re-uses the SAME key (harmless with upsert:false).
export function deliveryPhotoKey(siteKey, action, item, day, mime, uniq) {
  const base = safe(idem(siteKey, action, item, day), 120) || "photo";
  const suffix = uniq != null && String(uniq) !== "" ? "__" + safe(uniq, 40) : "";
  return `${siteKey || "unknown"}/${day || "nodate"}/${base}${suffix}.${extFor(mime)}`;
}
